module.exports = __webpack_public_path__ + "static/media/question.82e85430.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/question.png
// module id = 131
// module chunks = 0